import { Link } from '@overdose/components'
import { useAlgoliaSearchInsignts } from '~/hooks'

import { CategoryCardOverlayLinkProps } from './CategoryCardOverlayLink.types'

export const CategoryCardOverlayLink = ({
  url,
  title,
  sku,
}: CategoryCardOverlayLinkProps) => {
  const { sendViewProductsEvent } = useAlgoliaSearchInsignts()

  if (!url) {
    return null
  }

  return (
    <Link
      className='absolute z-10 inset-0'
      to={url}
      onClick={() => {
        if (sku) {
          sendViewProductsEvent([
            {
              title,
              url,
              listId: sku,
            },
          ])
        }
      }}
    />
  )
}
